const E164 = /^\+[1-9]\d{6,14}$/;

/**
 * Turns what the trader typed into the E.164 number the API expects (S4 R14).
 *
 * Spaces, dots, dashes and parentheses are removed. A number without the leading `+` is refused:
 * the country is unknown, so guessing one would send a code to a stranger (I9).
 *
 * @returns The number, or `null` when it is not an E.164 number after cleaning.
 */
export function normalizePhone(input: string): string | null {
  const cleaned = input.trim().replaceAll(/[\s().-]/g, '');
  return E164.test(cleaned) ? cleaned : null;
}
